export type TNativeAudioNode = AudioNode;
